import Vuex from 'vuex'
import Vue from 'vue'
import common from './modules/common.js'
// TODO 将websocket封装到vuex
// import websocket from './modules/websocket.js';
import e000102 from './modules/e000102.js';
import b000201 from './modules/b000201.js';
import c000201 from './modules/c000201.js';
import d000103 from './modules/d000103.js';
import d000201 from "./modules/d000201.js";
import e000201 from './modules/e000201.js';
import panoramicData from './modules/panoramicData.js';
import jCourse from './modules/jCourse.js'
import createPersistedState from "vuex-persistedstate";
import exam from './modules/exam.js';
import theme from "./modules/theme";
import reviewManage from "./modules/reviewManage";
import testPaper from "./modules/testPaper";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common,
        b000201,
        c000201,
        d000103,
        d000201,
        e000102,
        e000201,
        panoramicData,
        exam,
        theme,
        jCourse,
        reviewManage,
        testPaper
    },
    plugins: [
        createPersistedState({ storage: window.sessionStorage })
    ]
})



// WEBPACK FOOTER //
// ./src/store/store.js